import Vue from 'vue'
import axios from 'axios'

if (document.getElementById('vue-contact')) {
    new Vue({
        delimiters: ["[[", "]]"],
        el: '#vue-contact',
        data() {
            return {
                grecaptcha_sitekey: '',
                form: {
                    name: '',
                    lastname: '',
                    category: '',
                    email: '',
                    message: '',
                    grecaptcha_token: ''
                },
                errors: {
                    name: '',
                    lastname: '',
                    category: '',
                    email: '',
                    message: '',
                    grecaptcha_token: '',
                    all: ''
                },
                success: false,
            }
        },
        mounted() {
            this.getRecaptchaSiteKey()
        },
        methods: {
            getRecaptchaSiteKey() {
                let grecaptcha_sitekey_obj = document.getElementById('grecaptcha_json');
                if (grecaptcha_sitekey_obj) {
                    this.grecaptcha_sitekey = JSON.parse(grecaptcha_sitekey_obj.innerHTML).sitekey
                }
            },
            resetErrors() {
                this.errors = {
                    name: '',
                    lastname: '',
                    category: '',
                    email: '',
                    message: '',
                    all: '',
                    grecaptcha_token: ''
                }
            },
            submitForm(e) {
                e.preventDefault();
                this.resetErrors()
                grecaptcha.ready(() => {
                    grecaptcha.execute(this.grecaptcha_sitekey, {action: 'contact'}).then((token) => {
                        this.form.grecaptcha_token = token
                        axios.request({
                            method: 'POST',
                            url: "/wp-json/vq/v1/contact",
                            data: this.form,
                            headers: {
                                'content-type': 'application/json',
                            }
                        }).then(response => {
                            this.success = true
                            this.form = {
                                name: '',
                                lastname: '',
                                category: '',
                                email: '',
                                message: '',
                                grecaptcha_token: ''
                            }
                        }).catch((error) => {
                            console.log('error',error.response.data.message)
                            this.errors = Object.assign(this.errors, error.response.data.data.params)
                            this.errors.all = error.response.data.message
                        })
                    })
                })
            }
        }
    })
}